import { IosShare } from '@mui/icons-material'
import { Box, IconButton, Tooltip } from '@mui/material'
import * as React from 'react'
import { triggerShare } from '../utilities/browser'
import TooltipTitle from './tooltip-title'

let showTextTimeout
export const ShareButton = ({
  text,
  children
}: {
  text?: string
  children?: (handleCopy: () => Promise<void>) => React.ReactNode
}) => {
  const [showCopiedText, setShowCopiedText] = React.useState(false)
  const copyRef = React.createRef<HTMLDivElement>()
  React.useEffect(() => {
    showTextTimeout = setTimeout(() => setShowCopiedText(false), 2000)
    return () => {
      clearTimeout(showTextTimeout)
    }
  }, [showCopiedText])

  const handleCopy = async () => {
    const copied = await triggerShare(text, copyRef.current || undefined)
    if (copied) {
      setShowCopiedText(true)
    }
  }

  return (
    <Tooltip
      placement="top"
      title={<TooltipTitle description={`Link copied`} />}
      PopperProps={{
        open: showCopiedText
      }}
      disableHoverListener
      sx={{
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <Box>
        <div ref={copyRef}></div>
        {children ? (
          children(handleCopy)
        ) : (
          <IconButton color="secondary" onClick={handleCopy}>
            <IosShare />
          </IconButton>
        )}
      </Box>
    </Tooltip>
  )
}
